<template><div><dt-stack gap="600" class="d-mbs-600">
  <div>
    <h2 class="d-docsite--header-3 d-mbs-0 d-mbs-0">Core Color</h2>
    <p class="d-docsite--paragraph">Dialpad’s color theory is organized into three schemes depending on usage.</p>
    <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
      <div>
        <h3 class="d-docsite--header-4 d-mbs-0 d-mbs-0">Primary</h3>
        <p class="d-docsite--paragraph">For most general brand communications use light and dark neutrals for backgrounds with purple and a warm gradient tone used for accents.</p>
        <h3 class="d-docsite--header-4 d-mbs-0 d-mbs-0">Secondary</h3>
        <p class="d-docsite--paragraph">For specialty brand communications use one of the Dialpad brand purples for backgrounds.</p>
      </div>
      <div class="d-gc2">
        <svg-loader class="d-bar-500" name="color-marketing--01" />
      </div>
    </div>
  </div>
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <p class="d-docsite--paragraph">When creating attract and engage level communications, especially when using an increased amount of text, use the light background.</p>
    </div>
    <div class="d-gc2">
      <svg-loader class="d-bar-500" name="color-marketing--02" />
    </div>
  </div>
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <h2 class="d-docsite--header-3 d-mbs-0">In Product</h2>
      <p class="d-docsite--paragraph">Use the icon as a logomark to identify the application in headers, as an app icon, or favicon.</p>
      <p class="d-docsite--paragraph"><dt-link href="#">View Dialtone Icon</dt-link></p>
    </div>
    <div class="d-gc2">
      <svg-loader class="d-bar-500" name="color-marketing--03" />
    </div>
  </div>
  <figure>
    <svg-loader class="d-bar-500" name="color-marketing--04" />
  </figure>
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols2 d-ai-center">
    <figure>
      <svg-loader class="d-bar-500" name="color-marketing--05" />
    </figure>
    <figure>
      <svg-loader class="d-bar-500" name="color-marketing--06" />
    </figure>
  </div>
</dt-stack>
</div></template>


